import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_SELECTORS = [
  '.review-card',
  '.workshop-card',
  '.benefit-item',
  '.feature-item',
  '.testimonial-card',
  '.stat-item',
  '.premium-offering-card',
  '.fade-in-scroll',
  '.fade-up-scroll',
];

export const useScrollAnimation = (selectors = DEFAULT_SELECTORS) => {
  const location = useLocation();
  const selectorKey = selectors.join(',');

  useEffect(() => {
    if (typeof document === 'undefined' || !selectors.length) return undefined;
    const elements = selectors.flatMap((selector) => Array.from(document.querySelectorAll(selector)));
    if (!elements.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('in-view');
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' },
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- selectorKey encodes selectors list
  }, [location.pathname, selectorKey]);
};
